import { useEffect, useRef, useState } from 'react';
import abcjs from 'abcjs';
import { sanitizeAbcBody } from './sanitizeAbcBody';


export default function AbcNotation({ abc }) {
  const desktopRef = useRef(null);
  const mobileRef = useRef(null);
  const [showMobile, setShowMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth < 500 : false
  );
const [orientation, setOrientation] = useState('portrait');


function countMusicalBars(line) {
  return line
    .replace(/"[^"]*"/g, '')   // remove chords
    .replace(/\{[^}]*\}/g, '') // remove ornaments
    .replace(/![^!]*!/g, '')   // remove decorations (!trill!)
    .split('|')
    .filter(bar => bar.trim() !== '')
    .length;
}


function formatAbcForDisplay(abc, barsPerLine = 4) {
  const lines = abc.split('\n');
  const output = [];

  for (const line of lines) {
    if (/^[A-Z]:/.test(line.trim())) {
      output.push(line);
      continue;
    }

    const tokens = line
      .split(/(\[[12]:|\|:|\:\||\|\||\|]|\||"[^"]*"|[^|]+)/g)
      .filter(t => t && t.trim() !== '');

    const musicalTokens = [];
    let barCount = 0;

    // Collect all bars as bar groups
    const barGroups = [];
    let currentBar = [];

    for (let i = 0; i < tokens.length; i++) {
      const token = tokens[i];
      const isBar = token === '|';
      const isChord = /^".*"$/.test(token);
      const isHeader = /^[A-Z]:/.test(token);
      const isSection = ['||', ':|', '|]'].includes(token);
      const isEnding = /\[[12]:/.test(token);

      currentBar.push(token);

      if (isBar) {
        barGroups.push(currentBar.join('').trim());
        currentBar = [];
        barCount++;
      }

      if (isSection || isEnding) {
  // Treat as suffix to current bar, not its own group
  if (currentBar.length > 0) {
    currentBar.push(token);
  } else if (barGroups.length > 0) {
    // attach to previous bar group
    barGroups[barGroups.length - 1] += ' ' + token;
  } else {
    // rare case — just push standalone
    barGroups.push(token);
  }
}

    }

    if (currentBar.length) {
      barGroups.push(currentBar.join('').trim());
    }

    // Now group bars into lines of max N, but prevent 1-bar leftovers
    let i = 0;
    while (i < barGroups.length) {
  let lineBars = [];
  let barsThisLine = 0;

  while (i < barGroups.length && barsThisLine < barsPerLine) {
    const item = barGroups[i];

    if (!/^[|:]/.test(item) && !item.includes('|')) {
      lineBars.push(item);
      i++;
      continue;
    }

    const lookahead = barGroups.slice(i, i + (barsPerLine - barsThisLine));
    const futureBars = lookahead.filter(b => b.includes('|')).length;
    const barsRemaining = barGroups.slice(i).filter(b => b.includes('|')).length;
    const willLeaveOne = barsRemaining - 1 === 0;

    lineBars.push(item);
    i++;
    if (item.includes('|')) barsThisLine++;

    if (barsThisLine === barsPerLine || willLeaveOne) break;
  }

  const line = lineBars.join(' ').trim();
  output.push(line);
}

  }
// Final post-pass: merge last line with previous if it only has 1 bar
if (
  output.length >= 2 &&
  countMusicalBars(output[output.length - 1]) === 1
) {
  const last = output.pop();
  output[output.length - 1] += ' ' + last;
}


  return output.join('\n');
}






useEffect(() => {
  const handleResize = () => {
    setShowMobile(window.innerWidth < 500);
    setOrientation(window.innerWidth > window.innerHeight ? 'landscape' : 'portrait');
  };
  handleResize(); // run on first mount
  window.addEventListener('resize', handleResize);
  return () => window.removeEventListener('resize', handleResize);
}, []);


useEffect(() => {
  const cleanedAbc = sanitizeAbcBody(abc);
  const formattedAbc = formatAbcForDisplay(cleanedAbc, 4);
 // or 2 if you want 2 bars per line

    // Desktop version
    if (desktopRef.current) {
      abcjs.renderAbc(desktopRef.current, formattedAbc, {
        add_classes: true,
        scale: 0.7,
        staffwidth: 500,
        paddingtop: 10,
        paddingleft: 10,
        paddingright: 10,
        paddingbottom: 10,
      });
    }

    // Mobile/portrait version
if (mobileRef.current) {
  const isPortrait = orientation === 'portrait';
  abcjs.renderAbc(mobileRef.current, formattedAbc, {
    add_classes: true,
    scale: isPortrait ? 0.5 : 0.6,
    staffwidth: isPortrait ? 330 : 400,
    paddingleft: isPortrait ? 10 : 20,
    paddingright: isPortrait ? 40 : 15,
    paddingbottom: 4,
    paddingtop: 4,
  });
}

  }, [abc]);

  return (
    <div style={{ position: 'relative' }}>
      <div
        ref={desktopRef}
        className="abcjs-container"
        style={{
          display: showMobile ? 'none' : 'block',
          backgroundColor: '#ffffff',
          color: '#000000',
          padding: '0.5rem',
          borderRadius: '6px',
          overflowX: 'auto',
        }}
      />
      <div
        ref={mobileRef}
        className="abcjs-container"
        style={{
          display: showMobile ? 'block' : 'none',
          backgroundColor: '#ffffff',
          color: '#000000',
          padding: '0.5rem',
          borderRadius: '6px',
          overflowX: 'auto',
        }}
      />
    </div>
  );
}

